import HardwareSerializer from 'eflex/serializers/hardware';

export default class UniversalRobotSerializer extends HardwareSerializer {}
